import {
  BillingType,
  CompanyWithRelations,
  DistanceMetric,
  Language,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kLocations } from "./locations";

export const kCompany: CompanyWithRelations = {
  id: "00000011-0000-4000-a000-000000000002",
  name: "Workplaced Demo",
  language: "EN" as Language,
  forceGeofence: false,
  mandatoryCheckIn: false,
  parkingSpotsAsResourceEnabled: false,
  reservationWindowLength: 14,
  reservationWindowLengthDesk: 14,
  reservationWindowLengthLunch: 14,
  reservationWindowLengthMeeting: 14,
  reservationWindowLengthVisitor: 14,
  reservationWindowLengthResource: 14,
  forceTimeslotUse: false,
  checkInEnabled: true,
  lunchEnabled: true,
  visitorsEnabled: true,
  meetingEnabled: true,
  homeEnabled: true,
  recurringEnabled: true,
  recurringResourceReservationEnabled: false,
  overlappingUserReservationsEnabled: false,
  mapEnabled: true,
  presentpaneEnabled: true,
  multiSelectResourceEnabled: true,
  facilitymanagementEnabled: true,
  microsoftSsoEnabled: false,
  microsoftSyncEnabled: false,
  deskAutoCheckoutTime: 15,
  meetingAutoCheckoutTime: 15,
  lunchAutoCheckoutTime: 15,
  reservationForUserEnabled: true,
  hideCheckInTimeEnabled: false,
  visitorReservationConfirmEmailEnabled: true,
  compensationEnabled: false,
  created: "2025-03-22T19:59:44.996Z",
  contactFirstname: "Asael",
  contactLastname: "Akkerman",
  contactEmail: "asael@demo.workplaced.com",
  contactPhone: "1234 5678990",
  billingPricePerCustomer: 42.42,
  billingStartDate: "2025-03-23",
  billingId: 7,
  billingType: "month" as BillingType,
  compensationCutOffDay: null,
  compensationDistanceMetric: "kilometer" as DistanceMetric,
  compensationMaxDailyDistance: null,
  compensationDistanceUnitCompensation: null,
  compensationDailyHomeCompensation: null,
  compensationCurrencyCode: "EUR",
  compensationExportEmail: null,
  reservationAnonymousDays: null,
  visitorAnonymousDays: null,
  ssoDomain: "eduid.nl",
  surfconextSsoEnabled: true,
  saltoClientId: null,
  saltoClientSecret: null,
  saltoUsername: null,
  saltoPassword: null,
  tokens: [],
  locations: kLocations,
};
